/* icon/UI 24px/Print (printer).svg: width 24px x height 24px */
export default class DlsIconPrint extends HTMLElement {
  static define(tagName = 'dls-icon-print') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" display="block" pointer-events="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18 13.011c0-.554.439-1.011 1-1.011.54 0 1 .457 1 1.011 0 .534-.46.989-1 .989-.561 0-1-.455-1-.989z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M17.025 18.75h5.225v-9H1.75v9h5.276"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 15.75h10.5v5.5H6.75zm0-6v-7h10.5v7"/></svg>`;
  }
}
DlsIconPrint.define();
